import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr } from "../../Helper/ToastMessage";

export const PreventiveWorkReportTableDataAPI = createAsyncThunk("PreventiveWorkReportTableData", async ({ data }) => {
    const {
        UserID,
        token,
        M_ProjectID,
        FromDate,
        M_WardID,
        ToDate,
        M_WorkSubTypeID,
        handleGetPDFUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_RM_GD_T_KPIUploadPreventiveWorkSelect?M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WorkSubTypeID=${M_WorkSubTypeID ? M_WorkSubTypeID : '0'}&UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                handleGetPDFUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const PreventiveWorkReportTableDataSlice = createSlice({
    name: "PreventiveWorkReportTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PreventiveWorkReportTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PreventiveWorkReportTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PreventiveWorkReportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PreventiveWorkReportTableDataReducer = PreventiveWorkReportTableDataSlice.reducer